export const ROOM_TYPE = {
  ROOM: '1',
  LIFESTYLE: '2',
  SILO: '3',
  VIGNETTE: '4',
  THREESIXTY: '5',
  VIDEO: '6',
  CONFIGURATOR: '7',
  AUGMENTED_REALITY: '8',
}